var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondsvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00039 16.5L2.25039 9.825L6.00039 5.25H12.0004L15.7504 9.825L9.00039 16.5ZM3.43164 5.25L1.83789 3.65625L2.90664 2.60625L4.50039 4.2L3.43164 5.25ZM8.25039 3.75V1.5H9.75039V3.75H8.25039ZM14.5316 5.25L13.4629 4.18125L15.0566 2.5875L16.1254 3.65625L14.5316 5.25ZM9.00039 14.4L12.9379 10.5H5.06289L9.00039 14.4ZM6.71289 6.75L4.85664 9H13.1441L11.2879 6.75H6.71289Z",
    fill: "#A36E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondsvg);
export default __webpack_public_path__ + "static/media/diamondsvg.81f7381e96406bf3013150924ac425ce.svg";
export { ForwardRef as ReactComponent };